import { render, staticRenderFns } from "./PsgPanel.vue?vue&type=template&id=3848ec3d&scoped=true"
import script from "./PsgPanel.vue?vue&type=script&lang=js"
export * from "./PsgPanel.vue?vue&type=script&lang=js"
import style0 from "./PsgPanel.vue?vue&type=style&index=0&id=3848ec3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848ec3d",
  null
  
)

export default component.exports